import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "action-menu-tab__text" }

interface Props {
  text: string
  isActive: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenuTab',
  props: {
    text: null,
    isActive: { type: Boolean }
  },
  emits: ["toggleActive"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'toggleActive'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  text: string
  isActive: boolean
};






const onToggleActive = () => {
  emits('toggleActive')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['action-menu-tab', { 'action-menu-tab--active': __props.isActive }]),
    onClick: onToggleActive
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.text), 1)
  ], 2))
}
}

})